import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { CornerLogis } from '../../helpers';

export const 코너로지스_상품_폐기_쿼리 = createQueryKeys('corner-logis-product-disposal', {
  상품_폐기_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetPageList.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetPageList.ResponseBody>({
        method: 'GET',
        path: '/api/v1/removalItem/getList',
        params: query,
        shopID,
      });
    },
  }),
});
